import React, {Component} from 'react';

import Box from "./components/box/index";
import './styles.scss';
import axios from "axios/index";
import _ from "lodash";
import urls from "../../../utils/urls";
import {ajaxHandler} from "../../../utils/errors";
import {tokenHeader} from "../../../utils/headers";
import {connect} from "react-redux";

class Table extends Component {

    constructor(props) {
        super(props);
        this.state = {
            xhr: false,
            data: false,
            axiosSource: null
        }
    }

    componentDidMount() {
        this._fetchData();
    }

    _fetchData = () => {
        if (this.state.xhr) {
            this.state.axiosSource.cancel('abort');
        }
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();

        this.setState({xhr: true, axiosSource: source});

        let user_details_url = `${urls.API_ROOT}/api/v1/fuel-penetration-ytd/?`;
        if (this.props.navigation.selectedArea !== -1) {
            user_details_url = user_details_url.concat(`&area_id=${this.props.navigation.selectedArea}`);
        }
        if (this.props.navigation.selectedZone !== -1) {
            user_details_url = user_details_url.concat(`&zone_id=${this.props.navigation.selectedZone}`);
        }
        if (this.props.navigation.selectedStation !== -1) {
            user_details_url = user_details_url.concat(`&global_code=${this.props.navigation.selectedStation}`);
        }
        axios
            .get(user_details_url, {...tokenHeader(), cancelToken: source.token})
            .then((response) => this.setState({
                data: response.data,
                xhr: false, axiosSource: null
            },()=>console.log(this.state.data)))
            .catch(ajaxHandler);

    };

    render() {
        let variation1 = this.state.data.penultimate_ytd !== "-" ? `${_.round(this.state.data.previous_ytd - this.state.data.penultimate_ytd, 2)}%` : "-";
        let variation2 = this.state.data.actual_ytd!=="-" && this.state.data.previous_ytd!=="-"?`${_.round(this.state.data.actual_ytd - this.state.data.previous_ytd, 2)}%`:'-';
        let color1 = this.state.data.penultimate_ytd !== "-" ?
            _.round(this.state.data.previous_ytd - this.state.data.penultimate_ytd, 2) > 0 ?  "dd1d21":"#009EB4": "#585858";
        let color2 = _.round(this.state.data.actual_ytd - this.state.data.previous_ytd, 2) < 0 ? "dd1d21":"#009EB4";
        return (
            <div className={'table-section'}>
                {this.state.data &&
                <Box title={"Penetración SLP YTD"}
                     data1={this.state.data.previous_ytd!=='-'?`${this.state.data.previous_ytd}%`:'-'}
                     data2={this.state.data.actual_ytd!=='-'?`${this.state.data.actual_ytd}%`:'-'}
                     />}
                {this.state.data &&
                <Box title={"Variación YTD vs. año anterior"}
                     data1={variation1}
                     color1={color1}
                     color2={color2}
                     data2={variation2}/>}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        navigation: state.navigation
    }
};

export default connect(mapStateToProps)(Table);


// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/table/Table.js